import Ably from "ably/promises"
import { API_ABLY_KEY } from "../../../common/constants"
import React, { useState } from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { checkUserAccess, sendVerificationMessage, setOnboardingPhase, updateProfileDetails } from "../../../redux/actions/authentication"
import { toast } from "react-toastify"
import { IKImage } from "imagekitio-react"
import CountryCode from "../../LandingPage/CountryCode"
import _ from "lodash"
import { SET_IS_ACTIVATION, SET_MOBILE_NUMBER } from "../../../redux/actions/types"
import { fetchIsUserFromBetaProduct } from "../../../redux/actions/personaliseCourse"
import { getAllPersonalizeCourses, getPersonalizeUserData } from "../../../redux/actions/personalize"
import { setActivationPhase } from "../../../redux/actions/contentPayer"
import { useSearchParams } from "react-router-dom";
var client={}, channel={}

const Successful = ({
  selectedCountry,
  setSelectedCountry,
  phoneNumber,
  setPhoneNumber,
  setRenderComponent,
  setIsWhatsApp,
  scrollRef
}) => {
    const user_id = useSelector((store) => store?.profileDetails?.id)
    const email = useSelector((store)=> store?.profileDetails?.email);
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [sendCount, setSendCount] = useState(0)
    const [openWhatsApp, setOpenWhatsApp] = useState(false)
    const phoneNumberInStore = useSelector(
        (store) => store?.profileDetails?.["phone-number"]
    )
    const [disableButton , setDisableButton] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {

        if(scrollRef?.current){
          scrollRef?.current?.scrollIntoView({ behavior: 'smooth'})
        }
        webSocket();
        return () => {
        if (!(_.isEmpty(channel))){
            channel.unsubscribe();
            client.close()
            channel = {}
            client = {}
        }
        }
    }, [])

  console.log(client ,'client');
  console.log(channel , 'channel');
    function webSocket() {
        client = new Ably.Realtime(API_ABLY_KEY);

        client.connection.on("connected", (stateChange) => {
        console.log("Ably is connected");
        channel = client.channels.get(`verification_${user_id}`);

        channel.subscribe((newMessage) => {
            if (newMessage?.data?.user_id === user_id) {
                dispatch({type : SET_MOBILE_NUMBER , payload: { phone_number :  selectedCountry?.dial_code + phoneNumber , verified : true}})
                dispatch(fetchIsUserFromBetaProduct((successObj)=>{

                    const isPersonalizeUser = successObj?.data?.is_ninjacurate_user;
                    console.log('personalize' , isPersonalizeUser , successObj );


                    if(isPersonalizeUser){
                        dispatch(getPersonalizeUserData(
                            email,
                            (succesObj) => {
                              if(!succesObj?.Error){
                              dispatch(
                                getAllPersonalizeCourses(
                                  succesObj?.uid,
                                  succesObj?.access_token,
                                  (result) => {
                                    if(result?.length){
                                        
                                        dispatch(setOnboardingPhase((res1)=>{

                                            dispatch(setActivationPhase((res2)=>{
                                                dispatch({type : SET_IS_ACTIVATION ,payload : false});
                                                if(searchParams.get("course")){
                                                    navigate(`/popular-course/${searchParams?.get("course")}`);
                                                  }
                                                  else{
                                             navigate('/courses')}
                                                  

                                            } , (err2)=>{}))


                                        } , (err1)=>{}))
                                    }
                                    else{
                                        if(searchParams.get("course")){
                                            navigate(`/onboarding/${searchParams?.get("course")}`);
                                          }
                                          else{
                                            navigate('/onboarding')
                                          }
                                    }
                                  },
                                  (err) => {
                                    toast.error(err);
                                  }
                                )
                              );
                                }}))
                    }
                    else{
                        if(searchParams.get("course")){
                            navigate(`/onboarding/${searchParams?.get("course")}`);
                          }
                          else{
                            navigate('/onboarding')
                          }
                    }



                    } , (errorObj)=>{}))
            }
        });

        channel.history((err, resultPage) => {
            // display last message published
            const lastMessage = resultPage.items;
            console.log(lastMessage)
            for(let i=0;i<lastMessage.length ;i++){
                if(lastMessage[i]?.data?.user_id === user_id){
                    console.log('personalize1');
                    dispatch({type : SET_MOBILE_NUMBER , payload: { phone_number :  selectedCountry?.dial_code + phoneNumber , verified : true}})
                    if(searchParams.get("course")){
                        navigate(`/onboarding/${searchParams?.get("course")}`);
                      }
                      else{
                        navigate('/onboarding')
                      }
                    
                }
            }
        })
        setTimeout(() => {
            if (!(_.isEmpty(channel))){
                channel.unsubscribe();
                client.close();
                channel = {};
                client = {};
            }
        }, 60000)})
    }

    function onSubmit(phoneNumber, countryCode) {
        
        setDisableButton(true);
        dispatch(
        sendVerificationMessage(
            "one_click_verify",
            phoneNumber,
            (successObj) => {
            if (successObj?.result === "success") {
                if (!(_.isEmpty(channel))) {
                channel.unsubscribe();
                client.close();
                }
                webSocket();
                setSendCount((prev) => prev + 1);
            } else if (
                successObj?.result === "failed" &&
                successObj?.message === "OTP was not delivered"
            ) {
                setRenderComponent("technical");
            }
            else if(successObj?.result === "error" && successObj?.message === "User Already Verified"){
                dispatch({type : SET_MOBILE_NUMBER , payload: { phone_number :  phoneNumberInStore , verified : true}});
                dispatch(updateProfileDetails());
                // dispatch(fetchIsUserFromBetaProduct((successObj)=>{

                //     const isPersonalizeUser = successObj?.data?.is_ninjacurate_user;


                //     if(isPersonalizeUser){
                //         getPersonalizeUserData(
                //             email,
                //             (succesObj) => {
                //               if(!succesObj?.Error){
                //               dispatch(
                //                 getAllPersonalizeCourses(
                //                   succesObj?.uid,
                //                   succesObj?.access_token,
                //                   (result) => {
                //                     if(result?.length){
                                        
                //                         dispatch(setOnboardingPhase((res1)=>{

                //                             dispatch(setActivationPhase((res2)=>{
                //                                 dispatch({type : SET_IS_ACTIVATION ,payload : false});

                //                             } , (err2)=>{}))


                //                         } , (err1)=>{}))
                //                     }
                //                     else{
                //                         navigate("/onboarding")
                //                     }
                //                   },
                //                   (err) => {
                //                     toast.error(err);
                //                   }
                //                 )
                //               );
                //                 }})
                //     }
                //     else{
                //         dispatch(checkUserAccess((successObj)=>{ 
                //             if(successObj?.is_onboarded){
                //             navigate('/courses')}
                //             else{
                //             navigate('/onboarding')
                //             }  }))
                //     }



                //     } , (errorObj)=>{}))
                    dispatch(checkUserAccess((successObj)=>{ 
                        if(successObj?.is_onboarded){
                            if(searchParams.get("course")){
                                navigate(`/popular-course/${searchParams?.get("course")}`);
                              }
                              else{
                         navigate('/courses')}
                              }
                         else{

                            if(searchParams.get("course")){
                                navigate(`/onboarding/${searchParams?.get("course")}`);
                              }
                              else{
                                navigate('/onboarding')
                              }
                       
                      }  }))
               
            }
            else if(successObj?.result === "failed" && successObj?.message === 'Phone already in use')
            {
                toast.error(successObj?.message)
            }
            else {
                setRenderComponent("InValidWhatsApp");
            }

                setDisableButton(false);
            },
            (errorObj) => {
                toast.error(errorObj.message);
                setDisableButton(false);
            }
        )
        );
    }

    function whatsAppHandler() {
        window.open("https://wa.me/919642751247?text=Verify",'verify',"width=1000,height=800,top=100,left=100");
        setOpenWhatsApp(true);
        setTimeout(() => {
        setOpenWhatsApp(false);
        }, 5000);
    }

  return (
    <>
        <h2 className="mt-3 text-xl font-semibold text-white" ref={scrollRef}>Mobile Verification</h2>
        <h3 className="mt-1 font-bold text-white/80">Verify your number to unlock free access.</h3>
        <div className="mt-6 flex w-full flex-col justify-center text-white">
            <div className="flex justify-between">
                <label htmlFor="phone-number" className="ml-1 font-semibold text-white">WhatsApp Number</label>
                <div className="text-xs cursor-pointer mt-1 underline" onClick={(e) => {setRenderComponent("default")}}>Edit Number</div>
            </div>
            <div className="mb-2 flex w-full items-center gap-2 md:items-center md:justify-center">
                <div className="w-[30%] md:w-1/3">
                    <CountryCode
                        selected={selectedCountry}
                        setSelected={setSelectedCountry}
                        disable={false}
                    />
                </div>
                <div className="flex w-full flex-col mt-1">
                    <input
                    id="phone-number"
                    name="phone"
                    type="tel"
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    pattern="[0-9.]+"
                    required
                    disabled={true}
                    value={phoneNumber}
                    className={`w-full appearance-none text-white bg-[#223548] rounded-md border-gray-400 px-3 py-2 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 disabled:text-white sm:text-sm`}
                    />
                </div>
            </div>
            <button className="mt-4 w-full rounded-lg bg-[#13B284] py-2 px-2 text-white disabled:opacity-[0.3]"    disabled={true} onClick={(e) => onSubmit(selectedCountry?.dial_code + phoneNumber, selectedCountry?.code)}
            >WhatsApp Sent</button>
            {sendCount < 1 ? (
            <button
                className="text-sm md:text-sm cursor-pointer mt-2 underline"
                disabled={disableButton}
                onClick={(e) => onSubmit(selectedCountry?.dial_code + phoneNumber,selectedCountry?.code)}
            >Check Status/Resend WhatsApp</button>) : (
            <button
                className="text-md md:text-sm cursor-pointer mt-2 text-white underline"
                disabled={disableButton}
                onClick={(e) => setIsWhatsApp(false)}
            >Send OTP via SMS</button>)}
        </div>

        <div className="mt-4 flex flex-col items-start justify-center">
            <div className="self-start text-xl mb-1.5 font-semibold text-white">Verify on WhatsApp</div>
            <img
                urlEndpoint="https://assets.learntube.ai/files/"
                src={"https://assets.learntube.ai/files/homepage-banner/image.svg?ik-sdk-version=javascript-1.4.3&updatedAt=1675853405493"}
                transformation={[
                    {
                    height: "110",
                    width: "110",
                    },
                ]}
                className="w-full"
            />
        </div>
        <button 
            className="mt-4 w-full rounded-lg bg-[#1CA571] font-semibold py-3 px-2 text-white disabled:opacity-[0.3]"
            disabled={openWhatsApp}
            onClick={(e) => whatsAppHandler()}
        >Open WhatsApp</button>
    </>
  );
};

export default Successful;
